import { useContext, createContext } from 'react';

export const TimelineContext = createContext(null);

export function useTimelineContext() {
  return useContext(TimelineContext);
}
